var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.00003V12C15 13.1 14.1 14 13 14H2V7.62003C2.73 8.49003 3.85003 9.03003 5.09003 9.00003C6.10003 8.98003 7.01 8.59003 7.69 7.94003C8 7.68003 8.26002 7.35002 8.46002 6.99002C8.82002 6.38002 9.02 5.66 9 4.91C8.97 3.74 8.45001 2.71003 7.64001 2.00003H15Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14V17C22 18.66 20.66 20 19 20H18C18 18.9 17.1 18 16 18C14.9 18 14 18.9 14 20H10C10 18.9 9.1 18 8 18C6.9 18 6 18.9 6 20H5C3.34 20 2 18.66 2 17V14H13C14.1 14 15 13.1 15 12V5.00003H16.84C17.56 5.00003 18.22 5.39004 18.58 6.01004L20.29 9.00003H19C18.45 9.00003 18 9.45003 18 10V13C18 13.55 18.45 14 19 14H22Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22C9.10457 22 10 21.1046 10 20C10 18.8955 9.10457 18 8 18C6.89543 18 6 18.8955 6 20C6 21.1046 6.89543 22 8 22Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22C17.1046 22 18 21.1046 18 20C18 18.8955 17.1046 18 16 18C14.8954 18 14 18.8955 14 20C14 21.1046 14.8954 22 16 22Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12V14H19C18.45 14 18 13.55 18 13V10C18 9.45003 18.45 9.00003 19 9.00003H20.29L22 12Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99993 4.91002C9.01993 5.66002 8.81995 6.38004 8.45995 6.99004C8.25995 7.35004 7.99993 7.68005 7.68993 7.94005C7.00993 8.59005 6.09995 8.98005 5.08995 9.00005C3.84995 9.03005 2.72993 8.49005 1.99993 7.62005C1.85993 7.47005 1.73993 7.30005 1.62993 7.13005C1.23993 6.54005 1.01993 5.84008 0.999928 5.09008C0.969928 3.83008 1.52992 2.68004 2.42992 1.93004C3.10992 1.37004 3.9699 1.02005 4.9099 1.00005C5.9599 0.98005 6.91994 1.36005 7.63994 2.00005C8.44994 2.71005 8.96993 3.74002 8.99993 4.91002Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43994 5.03006L4.44995 5.99002L6.53992 3.97",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarApproved);
export default __webpack_public_path__ + "static/media/car-approved.0d0148256bdc90a77db35708236520e6.svg";
export { ForwardRef as ReactComponent };